<template>
  <div class="settings">
    <section class="settings__row">
      <h2>{{ $t('messages.settings.title') }}</h2>
    </section>
    <section class="settings__row settings__time">
      <h3><font-awesome-icon :icon="['custom', 'time-stamp']" /> {{ $t('messages.settings.time') }}</h3>
      <div class="settings__row__option">
        <span>{{ $t('messages.settings.use12HourClock') }}</span>
        <span
          class="g-btn g-btn--rounded g-btn--toggle"
          :class="{'active': computedUse12HourClock}"
          @click="setValue('settings.time.use12HourClock', !computedUse12HourClock)"
        />
      </div>
    </section>
    <section
      v-if="computedGetPermissions.stationEdit"
      class="settings__row settings__stations"
    >
      <h3><font-awesome-icon :icon="['custom', 'stations']" /> Stations</h3>
      <div class="settings__row__option">
        <span>Show Advanded Tab in Station Edit</span>
        <span
          class="g-btn g-btn--rounded g-btn--toggle"
          :class="{'active': computedStationsShowAdvancedTab}"
          @click="setValue('settings.stations.showAdvancedTab', !computedStationsShowAdvancedTab)"
        />
      </div>
    </section>
    <section class="settings__row settings__internationalization">
      <h3><font-awesome-icon :icon="['fas', 'globe']" /> {{ $t('messages.settings.language') }}</h3>
      <p>{{ $t('messages.settings.preferredLanguage') }}</p>
      <div class="settings__internationalization__languages">
        <button
          v-for = "locale in computedLocaleOverview"
          :key="locale.locale"
          class="g-btn g-btn--rounded settings__internationalization__languages__button"
          @click="setLocale(locale.locale)"
        >
          <img
            :src="require('@graphics/language_icons/'+locale.icon)"
            alt="locale.name"
          >
          <span>{{ locale.name }}</span>
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import {SocketHandler} from '@/assets/javascript/mixins/Mixins'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {setDomainCookie} from '@libs/cookie-handling'

export default {
  name: 'Settings',
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },
  mixins: [SocketHandler],
  props:
  {
    SocketMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    PageMessage: {
      type: Object,
      default: function() {
        return{}
      }
    },
    store: {
      type: Object,
      default: function() {
        return{}
      }
    }
  },
  data() {
    return{
    }
  },
  computed: {
    computedGetPermissions() {
      return this.store.getData('user.access')
    },
    computedStationsShowAdvancedTab() {
      return this.computedSettings.stations.showAdvancedTab
    },
    computedUse12HourClock() {
      return this.computedSettings.time.use12HourClock
    },
    computedSettings() {
      return this.store.getData('settings')
    },
    computedLocaleOverview() {
      return this.$i18n.localeOverview
    }
  },
  watch: {
    computedSettings: {
      handler() {
        localStorage.setItem('NGWI_SETTINGS', JSON.stringify(this.computedSettings))
      },
      deep: true
    }
  },
  methods: {
    setLocale(locale) {
      setDomainCookie(btoa(locale), 'lang', 999999)
      this.setValue('settings.internationalization.selectedLocale', locale)
    },
    setValue(option, value) {
      this.store.setData(option, value)
    }
  }
}
</script>

<style lang="scss">
  .settings {
    background: $color-white;
    border-radius: $application-base-border-radius;
    width: 85vw;
    max-width: 400px;

    h3 {
      margin: 10px 0 5px;
    }

    .g-btn {
      margin: 2px;
    }

    &__row {
      padding: $application-base-padding * 2;

      &:not(:last-child) {
        border-bottom: 1px solid $color-grey;
      }

      &__option {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    &__internationalization {
      &__languages {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
        align-items: center;
        justify-content: space-around;
        grid-gap: 5px;
        &__button {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          img {
            width: 18px;
          }
          img + span {
            padding-left: 5px;
          }
        }
      }
    }
  }
</style>
